import "./list.scss"

import DatatableOrder from "../../../pages/orders/OrderDataTable/DatatableOrder"

const ListOrder = () => {
  return (
    <div className="list">
     
      <div className="listContainer">
       
        <DatatableOrder />
      </div>
    </div>
  )
}

export default ListOrder